import { useLocation, useParams, Link } from 'react-router-dom';

export default function DealsView(){
  const { id } = useParams();
  const { state } = useLocation();
  const data = state && typeof state === 'object' ? state : null;

  return (
    <section>
      <div className="relative h-[40vh] md:h-[50vh]">
        <img alt={data?.name || `Deal ${id}`} src={`https://picsum.photos/seed/${data?.img || 'deal' + id}/1600/900`} className="absolute inset-0 w-full h-full object-cover"/>
        <div className="absolute inset-0 bg-black/30"/>
        <div className="absolute inset-0 flex items-end">
          <div className="container pb-8">
            <h1 className="text-white text-4xl md:text-5xl font-extrabold">{data?.name || `Deal #${id}`}</h1>
            <p className="text-white/90">{data?.place || 'Special destination'}</p>
          </div>
        </div>
      </div>

      <div className="container py-10 grid lg:grid-cols-[2fr,1fr] gap-8">
        <div className="space-y-6">
          <div className="card p-6">
            <h2 className="text-xl font-semibold">About this deal</h2>
            <p className="text-gray-700 mt-2">Enjoy an exclusive limited-time offer with selected dates and benefits. Perfect for spontaneous travelers looking for great value.</p>
          </div>
          <div className="card p-6">
            <h3 className="text-lg font-semibold">Includes</h3>
            <ul className="mt-2 text-sm text-gray-700 space-y-1">
              <li>• 3 nights accommodation</li>
              <li>• Daily breakfast</li>
              <li>• Airport transfers</li>
              <li>• Local tour voucher</li>
            </ul>
          </div>
        </div>
        <aside className="space-y-6">
          <div className="card p-6">
            <div className="text-2xl font-bold">${data?.price || '—'} <span className="text-gray-400 text-sm font-normal line-through ml-2">${data?.old || ''}</span></div>
            <div className="text-xs text-gray-500">Per Traveler • Limited time</div>
            <button className="btn-primary w-full mt-4">Book Now</button>
            <Link to="/" className="btn-outline w-full mt-2">Back to Home</Link>
          </div>
        </aside>
      </div>
    </section>
  );
}
